import { cn } from "@/lib/cn";

/**
 * Tellvue's wordmark for now: the name set in Wanted Sans. The SVGs in src/assets/brand are
 * Wanted's own marks and are not Tellvue's brand.
 */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn("wds-heading-1 font-bold tracking-tight text-label-strong", className)}>
      텔뷰
    </span>
  );
}
